module.exports = __webpack_public_path__ + "star-icon/star-icon-f507aea97470d3cce60ae8a5832a6675.svg";